module.exports = __webpack_public_path__ + "static/media/Logo - Verdant Odyssey.a45f941f.svg";